import { connect } from 'react-redux'
import validator from 'validator'
import { fullName, join, match, required, username } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'
import { strongPasswordConfig } from 'components/PasswordRequirements/PasswordRequirements.data'

import {
  doAcceptUserInvitation,
  doGetUserByInvitationOrRedirect,
} from '../actions'

import {
  selectFormFields,
  selectAcceptError,
  selectInvitationFound,
  selectIsLoading,
} from '../selectors'
import { selectOnboardingLayoutVariant } from '../../../selectors'

import AcceptInviteFormView from './view'

const validators = {
  firstLastNameInput: join([required, fullName]),
  usernameInput: join([required, username]),
  passwordInput: value =>
    !validator.isStrongPassword(value?.trim(), strongPasswordConfig) &&
    'Invalid password.',
  passwordConfirmInput: (...args) => {
    const errorMsg = join([required, match('passwordInput')])(...args)
    // Override the default match error message
    return errorMsg ? "Your passwords don't match" : undefined
  },
}

const apiFieldMapping = {
  name: 'firstLastNameInput',
  username: 'usernameInput',
  password: 'passwordInput',
  password_confirmation: 'passwordConfirmInput',
}

const select = state => ({
  apiFieldMapping,
  initialValues: selectFormFields(state),
  acceptError: selectAcceptError(state),
  invitationFound: selectInvitationFound(state),
  layoutVariant: selectOnboardingLayoutVariant(state),
  isLoading: selectIsLoading(state),
  validators,
})

const perform = {
  onSave: doAcceptUserInvitation,
  onLoad: doGetUserByInvitationOrRedirect,
}

export default connect(select, perform)(withFormFields(AcceptInviteFormView))
